import React, { useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import RenderOnRole from '../../../../components/RenderOnRole'
import {
  DIAGNOSIS_READ,
  HISTORY_READ,
  LAB_ORDERS_READ,
  MEDICATIONS_READ,
  SYSTEMIC_READ,
  VITALS_READ,
} from '../../../../utils/roles'
import OpdDentalMenu from './OpdDentalMenu'
import { id } from 'date-fns/locale'
import { startSxpProxy } from '../../../../utils/api'
import { OPD_PROJECT_ID } from '../../../../utils/constants'
import { getTotalAge } from '../../../../utils/dateUtils'
import { appointmentType } from '../../../OPDScreen/constant'
import { makeName } from '../../../lms/utils'
import { FormattedPatient } from '../../../patients/Patients'
import { capitalizeFirstLetter } from '../../../patients/utils'
import OPDPatientTable from '../../../OPDScreen/OpdScreen'
import OPDVisitsDetails from '../../../OPDScreen/visitDetails'
import DateofAppointments from '../../DateofAppointment'
import { Box, CircularProgress, Typography } from '@mui/material'
import {
  selectIsLoading,
  setIsDiagnosisOpdFormSubmit,
  setIsHistoryFormSubmit,
  setIsInitialLoad,
  setIsObjectiveOpdFormSubmit,
  setIsPainHistoryOpdFormSubmit,
  setIsSystemicExamOpdFormSubmit,
  setIsTreatmentPlanOpdFormSubmit,
  setIsVitalsFormSubmit,
  updateClinicalExamination,
  updateDiagnosis,
  updateExamination,
  updateHistoryExamination,
  updateObjectivePhysio,
  updatePainHistoryPhysio,
  updateSystemicExamination,
  updateTreatmentPlan,
  updateVitals,
} from '../opdFormsSlice'
import { useDispatch } from 'react-redux'
import { AppDispatch } from '../../../../app/store'
import { useAppSelector } from '../../../../app/hooks'
import ProtectedMic from '../../ProtectedMic'
interface VisitProps {
  appointmentId: string
  doctorId: string
}
const OpdDental: React.FC<VisitProps> = () => {
  const dispatch = useDispatch<AppDispatch>()
  const [show, setShow] = useState<boolean>(false)
  const [patientData, setPatientData] = useState<FormattedPatient[]>([])
  // const [visitsList, setVisitList] = useState<appointmentType[]>([])
  const [visitsDateList, setVisitsDateList] = useState<appointmentType[]>([])
  const [selectedDate, setSelectedDate] = useState(-1)
  const location = useLocation()
  const storepatentid = location?.state?.id
  const isLoading: any = useAppSelector(selectIsLoading)

  const visitDateHandler = (data: any, i: any) => {
    setSelectedDate(i)
  }

  const transformPatientData = (p: any): FormattedPatient => {
    const thop = p.identifier?.[0]
    const bahmni = p.identifier?.[2]
    const created = p.identifier?.[3]
    const regType = p.identifier?.[3]
    const invoice = p.identifier?.[5]
    const name = makeName(p.name)
    const age = getTotalAge(p.birthDate)
    const gender = capitalizeFirstLetter(p.gender)
    const tel1 = p.telecom?.find((prt: { use: string }) => prt.use === 'mobile')
    const tel2 = p.telecom?.find((prt: { use: string }) => prt.use === 'home')

    return {
      id: bahmni?.value ?? thop?.value ?? p.id ?? '',
      name: name.trim() ?? '',
      gender: gender ?? '',
      age: age ?? '',
      fhirId: p.id ?? '',
      thopId: thop?.value ?? '',
      invoiceId: invoice?.value ?? '',
      registeredOn: created?.period?.start ?? '',
      registrationType: regType?.value ?? '',
      mobile: tel1?.value ?? tel2?.value ?? '',
    }
  }

  useEffect(() => {
    const intent = 'getPatientVisits'
    const patientIntent = 'getPatientApi'
    const state = {
      id: storepatentid,
    }

    startSxpProxy(OPD_PROJECT_ID, intent, state)
      .then((res) => {
        if (res?.data?.entry) {
          // setVisitList(res?.data?.entry)
          setVisitsDateList(res?.data?.entry)
          setSelectedDate(0)
        } else {
          // setVisitList([])
        }
      })
      .catch((e) => console.log(e))

    startSxpProxy(OPD_PROJECT_ID, patientIntent, state)
      .then((res1) => {
        const data = Array.isArray(res1.data) ? res1.data : [res1.data]
        const formattedData = transformPatientData(data[0])
        setPatientData([formattedData])
        setShow(true)
      })
      .catch((f) => console.log(f))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  const patientTableContainerRef = useRef<HTMLDivElement | null>(null)
  useEffect(() => {
    const resizeHandler = () => {
      const container = patientTableContainerRef.current
      if (container) {
        const availableHeight: any =
          window.innerHeight - container.getBoundingClientRect().top
        container.style.maxHeight = `${availableHeight - 200}px`
      }
    }

    window.addEventListener('resize', resizeHandler)
    resizeHandler()

    return () => {
      window.removeEventListener('resize', resizeHandler)

      dispatch(setIsInitialLoad(true))
      dispatch(setIsHistoryFormSubmit(false))
      dispatch(setIsVitalsFormSubmit(false))
      dispatch(setIsTreatmentPlanOpdFormSubmit(false))
      dispatch(setIsSystemicExamOpdFormSubmit(false))
      dispatch(setIsDiagnosisOpdFormSubmit(false))
      dispatch(setIsObjectiveOpdFormSubmit(false))
      dispatch(setIsPainHistoryOpdFormSubmit(false))

      dispatch(
        updateHistoryExamination({
          wbps: '',
          chiefComplaints: '',
          historyOfPresentIllness: '',
          pastHistory: '',
          pastMedicalHistory: '',
          diet: '',
          sleep: '',
          bowelBladder: '',
          smokingHistory: '',
          alcoholicHistory: '',
          habitualHistory: '',
          obstetricHistory: '',
          familyHistory: '',
          historyDrugAllergies: '',
          previousSurgeries: '',
          height: '',
          weight: '',
          pallor: '',
          icterus: '',
          cyanosis: '',
          clubbing: '',
          lymphadenopathy: '',
          edema: '',
        })
      )
      dispatch(
        updateDiagnosis({
          provisionalDiagnosis: '',
          differentialDiagnosis: '',
          investigations: '',
          finalDiagnosis: '',
        })
      )
      dispatch(
        updateVitals({
          pulse: '',
          temperature: '',
          respiratoryRate: '',
          spo2: '',
          systolic: '',
          diastolic: '',
          posture: '',
        })
      )
      dispatch(
        updateSystemicExamination({
          localExamination: '',
          cardiovascularSystem: '',
          respiratorySystem: '',
          nervousSystem: '',
          perAbdomen: '',
        })
      )
      dispatch(
        updateTreatmentPlan({
          treatmentPlan: '',
          followUpAdvice: '',
          homeAdvice: '',
          followUpDate: '',
          referralRequired: '',
          department: '',
          nameOfDoctor: '',
          reasonReferral: '',
        })
      )
      dispatch(
        updatePainHistoryPhysio({
          accompanyingSymptoms: '',
          intensivity: '',
          painConstant: '',
          sensoryQualities: '',
          onset: '',
          whatRelievesPain: '',
          physicalActivity: '',
          concentration: '',
        })
      )
      dispatch(
        updateObjectivePhysio({
          gait: '',
          posture: '',
        })
      )
      dispatch(
        updateClinicalExamination({
          intraOralExamination: '',
          swelling: '',
          lymphnodeEnlargement: '',
          sinusOpening: '',
        })
      )
      dispatch(
        updateExamination({
          palpation: '',
          reflexes: '',
          rom: '',
          muscleAssessment: '',
          jointAssessment: '',
          relevantSpecialTests: '',
        })
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const element = (
    <div className='opd-container opd-height dental-container'>
      {show && (
        <div>
          <div>
            <OPDVisitsDetails />
          </div>
          <div className='opd-visittable'>
            <OPDPatientTable
              patients={patientData}
              isOpenDocsPage={true}
              display={true}
            />
          </div>
        </div>
      )}

      {isLoading && (
        <Box
          position='fixed'
          top={0}
          left={0}
          display='flex'
          justifyContent='center'
          alignItems='center'
          height='100vh'
          width='100vw'
          bgcolor='rgba(0, 0, 0, 0.4)'
          zIndex={1301}
        >
          <Box display='flex' flexDirection='column' alignItems='center'>
            <CircularProgress color='primary' />
            <Typography
              variant='h4'
              color='white'
              fontWeight='600'
              textAlign='center'
              mt={2}
            >
              Please wait. Transcription in progress...
              <br />
              Do not click Back or Refresh the page.
            </Typography>
          </Box>
        </Box>
      )}

      <div className='opd-menudates opd-dates-container flex-one full-content-width'>
        <div className='opdmenu'>
          <OpdDentalMenu />
        </div>
        <div className='opd-patient-dashboard'>
          {show && (
            <div>
              <DateofAppointments
                dateHandler={visitDateHandler}
                activeDate={selectedDate}
                visitDates={visitsDateList}
              />
            </div>
          )}
          <Box
            width={'100%'}
            display={'flex'}
            flexDirection={'row'}
            justifyContent={'space-around'}
            flex={1}
            marginTop={'3%'}
            overflow={'auto'}
            flexWrap={'wrap'}
            gap={1}
          >
            <ProtectedMic />
          </Box>
        </div>
      </div>
    </div>
  )
  return (
    <RenderOnRole
      roles={[
        HISTORY_READ,
        VITALS_READ,
        SYSTEMIC_READ,
        DIAGNOSIS_READ,
        MEDICATIONS_READ,
        LAB_ORDERS_READ,
      ]}
      element={element}
    />
  )
}

export default OpdDental
